import News from './News'
import Sent from './Sent'
import Drafts from './Drafts'
import Draft from './Draft'
import Edit from './Edit'
import Add from './Add'
import { makeEntityExistsGuard } from '../../store/utils'

export default [
  { path: '/news', name: 'news', component: News },
  { path: '/news/:id/show',
    name: 'news/show',
    component: Sent,
    beforeEnter: makeEntityExistsGuard('news')
  },
  { path: '/news/drafts', name: 'news/drafts', component: Drafts },
  { path: '/news/drafts/:id/show',
    name: 'news/drafts/show',
    component: Draft,
    beforeEnter: makeEntityExistsGuard('drafts')
  },
  { path: '/news/drafts/:id/edit',
    name: 'news/drafts/edit',
    component: Edit,
    beforeEnter: makeEntityExistsGuard('drafts')
  },
  { path: '/news/add', name: 'news/add', component: Add }
]



// WEBPACK FOOTER //
// ./src/components/news/routes.js